// Bermuda on-water event calendar — surfaced on /events to entice charter bookings.

export const SAILING_EVENTS = [
  {
    id: "antigua-bermuda",
    name: "Antigua Bermuda Race",
    dateLabel: "Apr 29 – May 7, 2026",
    startISO: "2026-04-29",
    endISO: "2026-05-07",
    tagline: "935 nautical miles of Atlantic ocean racing.",
    description:
      "Cheer the Antigua fleet into Bermuda as they close out one of the Caribbean's most storied offshore sprints. Watch arrivals from the water for the best seat in the house.",
    experience: "Daytime Cruise",
  },
  {
    id: "sail-gp",
    name: "Bermuda Sail Grand Prix",
    dateLabel: "May 9 – 10, 2026",
    startISO: "2026-05-09",
    endISO: "2026-05-10",
    tagline: "F50 catamarans flying at 60 mph in the Great Sound.",
    description:
      "The closest you'll ever be to foiling catamarans at full tilt. We position Anchor Management at the edge of the racecourse — champagne in hand, front-row view.",
    experience: "Corporate Events",
  },
  {
    id: "annapolis-bermuda",
    name: "Annapolis Bermuda Ocean Race",
    dateLabel: "June 5, 2026",
    startISO: "2026-06-05",
    endISO: "2026-06-05",
    tagline: "753 nautical miles, Chesapeake to Bermuda.",
    description:
      "Catch the finishers crossing the line off St. David's. A bluewater classic with a soulful fleet — perfect for a sundowner cruise as the pros arrive.",
    experience: "Sunset Sails",
  },
  {
    id: "newport-bermuda",
    name: "Newport Bermuda Race",
    dateLabel: "June 19, 2026",
    startISO: "2026-06-19",
    endISO: "2026-06-19",
    tagline: "The 'Thrash to the Onion Patch' — Bermuda's crown jewel regatta.",
    description:
      "Watch the world's great ocean racers finish after 635 miles of Atlantic weather. Our favourite week of the year: book early, this one sells out.",
    experience: "Daytime Cruise",
  },
  {
    id: "triple-crown",
    name: "Bermuda Triple Crown Billfish Championship",
    dateLabel: "July 3 – 21, 2026",
    startISO: "2026-07-03",
    endISO: "2026-07-21",
    tagline: "Three tournaments, three weeks, one legendary summer.",
    description:
      "Host your sport-fishing guests in style between tournaments, or enjoy quiet sails while the fleet's out. Popular dates book months in advance.",
    experience: "Overnight Stays",
  },
  {
    id: "non-mariners",
    name: "Non-Mariners Day",
    dateLabel: "August 2, 2026",
    startISO: "2026-08-02",
    endISO: "2026-08-02",
    tagline: "Bermuda's most creative (and floating) party.",
    description:
      "Mangrove Bay transforms into a flotilla of homemade vessels, DJs, and neighbours swimming between boats. We'll take you right to the heart of it.",
    experience: "Daytime Cruise",
  },
  {
    id: "round-the-sound",
    name: "Round the Sound",
    dateLabel: "October 11, 2026",
    startISO: "2026-10-11",
    endISO: "2026-10-11",
    tagline: "A friendly circumnavigation of the Great Sound.",
    description:
      "One of the most scenic local regattas of the year. Crisp autumn light, gentle winds, and a fleet you can follow at sailor's pace.",
    experience: "Sunset Sails",
  },
];

export const POWER_BOAT_RACES = [
  { id: "pb-may-03", dateLabel: "May 3, 2026", isoDate: "2026-05-03", location: "Ferry Reach" },
  { id: "pb-may-17", dateLabel: "May 17, 2026", isoDate: "2026-05-17", location: "Ferry Reach" },
  { id: "pb-jun-07", dateLabel: "June 7, 2026", isoDate: "2026-06-07", location: "Ferry Reach" },
  { id: "pb-jul-05", dateLabel: "July 5, 2026", isoDate: "2026-07-05", location: "Ferry Reach" },
  { id: "pb-jul-19", dateLabel: "July 19, 2026", isoDate: "2026-07-19", location: "Ferry Reach" },
  { id: "pb-aug-09", dateLabel: "August 9, 2026", isoDate: "2026-08-09", location: "Ferry Reach" },
  { id: "pb-aug-30", dateLabel: "August 30, 2026", isoDate: "2026-08-30", location: "Ferry Reach" },
  { id: "pb-sep-13", dateLabel: "September 13, 2026", isoDate: "2026-09-13", location: "Ferry Reach" },
  { id: "pb-sep-27", dateLabel: "September 27, 2026", isoDate: "2026-09-27", location: "Ferry Reach" },
];
